
import ajax from "./ajax";
import fileImage from "./ajax";

//登录

export const login = params => ajax(`/login/submitLogin`, params,'POST');
//
export const userList = params => ajax(`/user/listByCondition`, params,'POST');
//新闻分页查询
export const listByPageArticle = params => ajax(`/article/listByPage`, params,'POST');

//新增新闻
export const insertArticle = params => ajax(`/article/insert`, params,'POST');

//修改新闻  /article/update
export const updateArticle = params => ajax(`/article/update`, params,'POST');

//删除新闻
export const deleteArticle = params => ajax(`/article/delete`, params,'POST');

//撤回新闻  
export const retractArticle = params => ajax(`/article/retract`, params,'POST');

//撤回新闻  
export const publishArticle = params => ajax(`/article/publish`, params,'POST');

//根据ID查询新闻   /user/listByIds
export const listByIdsArticle = params => ajax(`/article/listByIds`, params,'POST');


//栏目分页查询  programa
export const listByPagePrograma = params => ajax(`/programa/listByPage`, params,'POST');

//栏目列表查询  programa
export const listPrograma = params => ajax(`/programa/listByPage`, params,'POST')

//栏目删除   
export const deletePrograma = params => ajax(`/programa/delete`, params,'POST');

//栏目新增  
export const insertPrograma = params => ajax(`/programa/insert`, params,'POST');


//
//栏目修改 
export const updatePrograma = params => ajax(`/programa/update`, params,'POST');



//上传文件
export const fileUpload = params => ajax(`/article/fileUpload`, params,'POST');

//上传封面
// export const pictureUpload = params => fileImage(`/file/UploadPng`, params);
export const pictureUpload = params => fileImage(`/file/fileupload`, params);























